export default class Config {
    env() {
        const config = {
            local: {
                hostname: "localhost",
                // url: "http://localhost:3001",
                url: "https://api-vca.ypc.solutions",
                ws: "ws://localhost:7560",
                environment: "local",
            },
            prod: {
                hostname: "vca.ypc.solutions",
                url: "https://api-vca.ypc.solutions",
                ws: "wss://ws-vca.ypc.solutions",
                environment: "prod",
            },
        };
        return {
            api: config.local.hostname === window.location.hostname ? config.local.url : config.prod.url,
            ws: config.local.hostname === window.location.hostname ? config.local.ws : config.prod.ws,
            environment: config.local.hostname === window.location.hostname ? config.local.environment : config.prod.environment,
        };
    }

    // SIP / FreeSWITCH endpoints. Separate from env() above because these
    // live on their own host (siptestea) rather than the api-vca / ws-vca
    // pair, and are the same in local and prod — there's no local SIP stack
    // to point at. Collected here so the host appears in exactly one place
    // instead of being repeated across the webphone hooks.
    //
    // NOTE: the call queue is NOT here. call-queue-v3 is served from ws-vca
    // alongside call-status and bhvm-tickets, so it goes through the normal
    // _ws_handler in routes/dashboard/index.tsx like the other two.
    sip() {
        const base = "siptestea.ypc.solutions";
        return {
            /** REST base for SIP credentials. */
            api: `https://${base}`,
            /** Conference control REST base. */
            conferenceApi: `https://${base}/api/conference`,
            /** Conference participants push (per-agent room). */
            conferenceWs: `wss://${base}/ws/conference`,
        };
    }
}
